import initialiseModule from "Modules/EmbeddedVideoPlayer/EmbeddedVideoPlayerManager";

// API
export default {
  initModule: initialiseModule
}